import { useMemo, useEffect, useState } from 'react'

import {
  TextSize,
  TextType,
  TextWeight,
} from '@interco/inter-toranja/dist/components/Atoms/Text/types'
import IcWarningCircle from '@interco/icons/core/status/ic_warning_circle'
import { Text } from '@interco/inter-toranja'
import IcCheckCircleFill from '@interco/icons/core/status/ic_check_circle_fill'
import { FlexRow } from '@interco/inter-ui/components/Flex'

export default function ValidationItem({
  isValid,
  text,
  showFeedback,
}: {
  isValid: boolean
  text: string
  showFeedback: boolean
}) {
  const [, forceUpdate] = useState({})

  useEffect(() => {
    const handleStorageChange = () => {
      forceUpdate({})
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [])

  const icon = useMemo(() => {
    if (showFeedback && isValid) {
      return <IcCheckCircleFill width={18} height={18} color="#80E7BD" />
    }

    const getIconColor = () => {
      if (!showFeedback) {
        // Item pendente: cinza no light mode, cor da fonte no dark mode
        const isDarkMode = localStorage.getItem('isDarkMode') === 'true'
        if (isDarkMode) {
          // Obtém a cor da fonte padrão do tema dark
          // Tenta várias variáveis CSS comuns para cor de texto
          const textColor =
            getComputedStyle(document.documentElement)
              .getPropertyValue('--color-text-neutral-primary')
              .trim() ||
            getComputedStyle(document.documentElement)
              .getPropertyValue('--color-text-primary')
              .trim() ||
            getComputedStyle(document.body).color ||
            '#FFFFFF'
          return textColor
        }
        return '#756E6D'
      }
      // Item inválido: vermelho
      return '#D32F2F'
    }

    return <IcWarningCircle width={18} height={18} color={getIconColor()} />
  }, [isValid, showFeedback])

  return (
    <FlexRow alignItems="center" justifyContent="start" gap="4px">
      {icon}
      <Text textSize={TextSize.Medium} textWeight={TextWeight.Regular} textType={TextType.Label}>
        {text}
      </Text>
    </FlexRow>
  )
}
